module.exports = __webpack_public_path__ + "img/podakun.e1da8b37.svg";